import React from 'react';
import { FaArrowRight, FaPlay } from 'react-icons/fa';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-20"
      data-testid="hero-section"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB0cmFpbmluZ3xlbnwwfHx8fDE3NzUxOTM0NDZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Corporate Training"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-purple-900/85 to-blue-900/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8 animate-fade-in">
          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
            <span className="block" data-testid="hero-title">Vlinkin Professionals LLP</span>
            <span className="block mt-2 bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Empowering Minds, Transforming Futures
            </span>
          </h1>

          {/* Taglines */}
          <div className="space-y-3 text-xl md:text-2xl text-white/90 font-medium">
            <p data-testid="hero-tagline-1">Your Gateway To Educational Excellence</p>
            <p data-testid="hero-tagline-2">Connecting Learning And Corporate Brilliance</p>
            <p data-testid="hero-tagline-3">Elevate Skills With Bridge-to-Corporate</p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <button
              onClick={() => scrollToSection('programs')}
              className="group bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all flex items-center gap-2"
              data-testid="hero-explore-programs-btn"
            >
              Explore Programs
              <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all"
              data-testid="hero-contact-btn"
            >
              Get Started
            </button>
          </div>

          {/* Stats Preview */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 pt-16 max-w-4xl mx-auto">
            <div className="text-center" data-testid="hero-stat-students">
              <div className="text-4xl md:text-5xl font-bold text-white">10,000+</div>
              <div className="text-white/80 mt-2">Target Resource Pool</div>
            </div>
            <div className="text-center" data-testid="hero-stat-partners">
              <div className="text-4xl md:text-5xl font-bold text-white">15+</div>
              <div className="text-white/80 mt-2">Partner Institutions</div>
            </div>
            <div className="text-center" data-testid="hero-stat-success">
              <div className="text-4xl md:text-5xl font-bold text-white">95%</div>
              <div className="text-white/80 mt-2">Success Rate</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;